import {
  Button,
  Flex,
  SparkleIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import { useCallback } from 'react';

import type { FilterBarPopoverProps } from './filterBarPopover.types';
import { FilterPopover } from './filterPopover';

export const FilterBarClickableOptions = ({
  filterGroup,
  isLoading,
  onChange,
  onDeselect,
  onOpen,
  totalResults,
  variant,
}: FilterBarPopoverProps) => {
  const isMobile = useMobileMediaQuery({});
  const { label, items, nested, key } = filterGroup;

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (isOpen && onOpen) {
        onOpen(key);
      }
    },
    [onOpen, key]
  );

  const renderedFilterButtons = items.map((item) => {
    return (
      <Button
        key={item.value}
        startIcon={isMobile && <SparkleIcon color="primary" size="md" />}
        label={
          <Typography
            variant="body-bold"
            maxLines={1}
            overflowWrap="anywhere"
            truncateAt="240px"
          >
            {item.label}
          </Typography>
        }
        onClick={() => onChange(key, item.value)}
        variant="tertiary"
        alignment="left"
        size={isMobile ? 'large' : 'default'}
        full={isMobile}
      />
    );
  });

  return (
    <FilterPopover
      disabledDeselectAll
      buttonText={label}
      targetLabel={`Explore by ${label}`}
      isLoading={isLoading}
      listLabel={`Clickable options for ${label}`}
      onDeselect={() => onDeselect(key)}
      onOpenChange={onOpen ? handleOpenChange : undefined}
      disabled={items.length === 0}
      totalResults={totalResults}
      nested={nested}
      variant={variant}
      startIcon={<SparkleIcon color="primary" size="md" />}
      mobileItemsPerRow={1}
    >
      <Flex
        flexDirection="column"
        gap={isMobile ? 16 : 8}
        p={isMobile ? 0 : 24}
      >
        {renderedFilterButtons}
      </Flex>
    </FilterPopover>
  );
};
